import React, { useMemo } from 'react'

import StepForm from '../../../../../../../features/components/Forms/StepForm'

import { useCreateGamAd } from '../../hooks/useCreateGamAd'

import { IMAGE_EXISTING_LIBRARY_TYPE } from '../../fields'
import AdQuarantineField from '../../../../../../ReusableFormFields/AdQuarantineField'

const ExistingImagesLibraryRoute = ({ FormRouteSelector, isInternalAdCreation, ...formProps }) => {
  const { purifiedFormik } = useCreateGamAd({
    isInternalAdCreation,
    formatOption: IMAGE_EXISTING_LIBRARY_TYPE
  })

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: () => (
          <div>
            Here will be Existing images libraries logic
            <AdQuarantineField formik={purifiedFormik} />
          </div>
        ),
        show: true
      }
    ],
    [FormRouteSelector, purifiedFormik]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default ExistingImagesLibraryRoute
